import { useMutation, useQueryClient } from '@tanstack/react-query';
import { converters as filesConverters, useDownloadPdf } from 'store/files';
import { TransmissionActDocument } from 'containers/transmission-acts';
import { Currency } from 'types/general';
import { adminTransmissionActsKeys } from './admin-transmission-acts.queries';
import { loaders } from './admin-transmission-acts.loaders';
import { converters } from './admin-transmission-acts.converters';

export const useAdminUpdateTransmissionAct = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateTransmissionAct, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminTransmissionActsKeys.all);
    },
  });
};

export const useRegenerateTransmissionActs = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.regenerateTransmissionActs, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminTransmissionActsKeys.all);
    },
  });
};

export const useExportToXls = () => {
  return useMutation(loaders.exportXls, {
    onSuccess: filesConverters.export,
  });
};

export const useDownloadTransmissionActPdfOnClient = () => {
  const { mutateAsync: downloadPdf } = useDownloadPdf();

  return useMutation(
    ({
      currency,
      ...parameters
    }: Parameters<typeof loaders.getTransmissionAct>[0] & {
      currency?: Currency;
    }) => loaders.getTransmissionAct(parameters),
    {
      onSuccess: async (data, { currency }) => {
        const transmissionAct = converters.getTransmissionAct(data);

        return downloadPdf({
          filename: `transmission-act-${transmissionAct.id}`,
          document: (
            <TransmissionActDocument
              transmissionAct={transmissionAct}
              currency={currency}
            />
          ),
        });
      },
    },
  );
};

export const useAdminDownloadTransmissionActPdfOnServer = () => {
  return useMutation(loaders.downloadPdf, {
    onSuccess: filesConverters.export,
  });
};

export const useSendTransmissionActPdf = () => {
  return useMutation(loaders.sendPdf);
};
